import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="首页横幅">
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20dreamy%20reading%20scene%20with%20floating%20comic%20pages%20and%20soft%20magical%20glowing%20particles%2C%20warm%20golden%20and%20soft%20pink%20ambient%20lighting%2C%20artistic%20and%20stylized%20composition%2C%20atmospheric%20depth%2C%20clean%20composition%20with%20ample%20negative%20space%2C%20whimsical%20and%20inviting%20mood&width=1800&height=900&seq=hero-bg-hanman&orientation=landscape"
        alt="韩漫在线免费看 - 韩国漫画网"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
            韩漫在线免费看
          </h1>
          <p className="text-sm md:text-lg text-background-200/90 mb-8 max-w-xl mx-auto leading-relaxed">
            海量韩漫免费漫画在线观看，支持下拉式免费阅读。涵盖恋爱、喜剧、奇幻、动作等各类韩国漫画，为您打造极致的在线阅读体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/romance"
              className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              开始阅读
              <span className="ml-2">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 rounded-lg border border-background-200/40 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">10000+</p>
              <p className="text-xs text-background-300 mt-1">漫画资源</p>
            </div>
            <div className="w-px h-10 bg-background-300/30"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">8大</p>
              <p className="text-xs text-background-300 mt-1">分类频道</p>
            </div>
            <div className="w-px h-10 bg-background-300/30"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">500万+</p>
              <p className="text-xs text-background-300 mt-1">忠实读者</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}